(function () {
  /* One copy of this file serves every Academy Education section on the page,
     so it keys off the panel element rather than a baked-in section id.

     NOTE: literal characters are used for the separators and a plain string
     test for the hostname. Unicode escapes here have to survive being written
     through the Admin API, and a double-escaped \\u2013 silently ships as text. */
  var initPanel = function (panel) {
    if (panel.dataset.acadReady === '1') return;
    panel.dataset.acadReady = '1';

    var cardsEl = panel.querySelector('[data-acad-cards]');
    var cityEl = panel.querySelector('[data-acad-city]');
    var tabs = [].slice.call(panel.querySelectorAll('[data-acad-tab]'));
    var calId = panel.dataset.calendarId;
    var uuid = panel.dataset.widgetUuid;
    var limit = parseInt(panel.dataset.limit, 10) || 6;
    var ticketsText = panel.dataset.ticketsText || 'Get your Tickets';
    var soldOutText = panel.dataset.soldoutText || 'Sold Out';
    var exclude = (panel.dataset.exclude || '').split(',')
      .map(function (t) { return t.trim().toLowerCase(); })
      .filter(Boolean);

    if (!calId || !uuid) {
      cardsEl.innerHTML = '<p class="acad__empty">Calendar is not configured yet.</p>';
      return;
    }

    var esc = function (v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };

    /* The app returns tickets on the myshopify domain; keep people on the
       storefront they are already browsing. */
    var fixLink = function (url) {
      if (!url) return '';
      try {
        var u = new URL(url, location.href);
        if (u.hostname.toLowerCase().indexOf('.myshopify.com') === u.hostname.length - 14) {
          u.hostname = location.hostname;
        }
        return u.href;
      } catch (e) { return url; }
    };

    var fmt = function (ts, tz, opts) {
      try {
        return new Intl.DateTimeFormat('en-AU', Object.assign({ timeZone: tz || 'Australia/Sydney' }, opts))
          .format(new Date(ts * 1000));
      } catch (e) {
        return new Intl.DateTimeFormat('en-AU', opts).format(new Date(ts * 1000));
      }
    };

    var all = [];

    var matchesCity = function (ev, terms) {
      if (!terms) return true;
      var hay = (ev.summary || '').toLowerCase();
      return terms.split(',').some(function (t) {
        t = t.trim().toLowerCase();
        return t && hay.indexOf(t) > -1;
      });
    };

    var render = function () {
      var active = tabs.filter(function (t) { return t.classList.contains('is-active'); })[0];
      var terms = active ? active.dataset.match : '';
      var label = active ? active.dataset.label : '';
      if (cityEl) cityEl.textContent = label ? '· ' + label : '';

      var list = all.filter(function (ev) { return matchesCity(ev, terms); }).slice(0, limit);

      if (!list.length) {
        cardsEl.innerHTML = '<p class="acad__empty">No upcoming Academy Days' +
          (label ? ' in ' + esc(label) : '') + ' right now.<br>New dates are added every month.</p>';
        return;
      }

      cardsEl.innerHTML = list.map(function (ev) {
        var tz = ev.timezone;
        var date = fmt(ev.utcStartTime, tz, { day: 'numeric', month: 'short', year: 'numeric' });
        var from = fmt(ev.utcStartTime, tz, { hour: '2-digit', minute: '2-digit', hour12: false });
        var to = ev.utcEndTime ? fmt(ev.utcEndTime, tz, { hour: '2-digit', minute: '2-digit', hour12: false }) : '';
        var abbr = ev.timezoneAbbreviation || '';
        var desc = String(ev.shortDescription || '').replace(/<[^>]+>/g, '').trim();
        var venue = ev.venueNameToggle === false ? '' : (ev.venueName || '');
        var link = fixLink(ev.ticketsLink || ev.shopifyProductUrl || ev.url);

        return '<article class="acad__card">' +
          '<div class="acad__card-top">' +
            '<span class="acad__date">' + esc(date) + '</span>' +
            (ev.soldOut ? '<span class="acad__flag">Sold out</span>' : '') +
          '</div>' +
          (desc ? '<p class="acad__card-desc">' + esc(desc) + '</p>' : '') +
          (venue ? '<div class="acad__meta">' + esc(venue) + '</div>' : '') +
          '<div class="acad__meta">' + esc(from) + (to ? ' – ' + esc(to) : '') + (abbr ? ' ' + esc(abbr) : '') + '</div>' +
          (ev.soldOut
            ? '<span class="button medium" aria-disabled="true">' + esc(soldOutText) + '</span>'
            : (link ? '<a class="button medium" href="' + esc(link) + '">' + esc(ticketsText) + '</a>' : '')) +
        '</article>';
      }).join('');
    };

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        render();
      });
    });

    var load = function () {
      var url = 'https://api.eventcalendarapp.com/events?id=' +
        encodeURIComponent(calId) + '&widgetUuid=' + encodeURIComponent(uuid);

      fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        var now = Date.now() / 1000;
        all = (j && j.events ? j.events : [])
          .filter(function (ev) {
            var title = (ev.summary || '').toLowerCase();
            /* Cancelled and private sessions stay in the feed with soldOut set
               and eventStatus still "scheduled", so they have to go by title. */
            if (exclude.some(function (t) { return title.indexOf(t) > -1; })) return false;
            return (ev.utcEndTime || ev.utcStartTime || 0) >= now;
          })
          .sort(function (a, b) { return (a.utcStartTime || 0) - (b.utcStartTime || 0); });
        render();
      }).catch(function () {
        cardsEl.innerHTML = '<p class="acad__empty">Upcoming dates could not be loaded just now.</p>';
      });
    };

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { load(); io.disconnect(); } });
      }, { rootMargin: '300px 0px' });
      io.observe(panel);
    } else {
      load();
    }
  };

  var boot = function (scope) {
    (scope || document).querySelectorAll('[data-acad-panel]').forEach(initPanel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  /* The theme editor re-renders a section in place; re-init the new copy. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();